import React from 'react';
import { KPICard } from './components/KPICard';
import { SalesChart } from './components/SalesChart';
import { LocationSalesChart } from './components/TopProductsChart';
import { DashboardFilters } from './components/DashboardFilters';
import { MiniInventoryTestButton } from '@/components/inventory/MiniInventoryTestButton';
import { useDashboardData } from './hooks/useDashboardData';

export const Dashboard: React.FC = () => {
  const {
    filters,
    setFilters,
    loading,
    kpis,
    salesData,
    realTimeMetrics,
    locationSalesData
  } = useDashboardData();


  return (
    <main className="p-6">
      <div className="mb-6 flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">Dashboard Ejecutivo</h1>
      </div>

      {/* Filtros */}
      <DashboardFilters filters={filters} onFiltersChange={setFilters} />

      <div className="space-y-6">
        {/* KPIs Principales */}
        <section>
          <h2 className="text-xl font-semibold mb-4">KPIs Principales</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {kpis.map((kpi) => (
              <KPICard key={kpi.id} kpi={kpi} />
            ))}
          </div>
        </section>

        {/* Tendencias */}
        <section>
          <h2 className="text-xl font-semibold mb-4">Tendencias</h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <SalesChart data={salesData} />
            <LocationSalesChart data={locationSalesData} />
          </div>
        </section>

      </div>

    </main>
  );
};